import script from "./TestReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestReport.vue?vue&type=script&setup=true&lang=ts"

import "../style/TestReport.css?vue&type=style&index=0&id=1d9b0a76&scoped=true&lang=css&external"
import "./TestReport.vue?vue&type=style&index=1&id=1d9b0a76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9b0a76"]])

export default __exports__